import Vue from 'vue';
import SvgIcon from '@/components/SvgIcon';
import '@/assets/icon/iconfont';
Vue.component('svg-icon', SvgIcon);
const requireAll = reqireContext => reqireContext.keys().map(reqireContext);
const req = require.context('./svg', false, /\.svg$/);
requireAll(req);